"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSBodyRightLayout = exports.DSBodyLeftLayout = exports.DSSBodyTitle = exports.DSBody = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const account_1 = require("../../account");
const function_1 = require("../../../menu/function");
exports.DSBody = react_1.default.memo(({ title, name, menuList, isWhite = false, hideBody = false, children, }) => {
    const { isDesktop, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const { menu } = (0, react_redux_1.useSelector)((state) => (0, function_1.getMenuData)(state), react_redux_1.shallowEqual);
    const isStudentReservation = !isTeacher && menu.menu === 'reservation';
    const renderIcon = (0, react_1.useMemo)(() => (react_1.default.createElement(common_1.Icon, { icon: "message", size: 32, fill: isWhite
            ? Colors_1.Colors.white
            : name === 'reservation'
                ? Colors_1.Colors.dark_blue
                : name === 'assignment'
                    ? Colors_1.Colors.tur
                    : Colors_1.Colors.pur })), [name]);
    return (react_1.default.createElement("div", { className: "body" },
        react_1.default.createElement("div", { className: `container2 ${isMobile && !isTeacher ? name : ''} ${isStudentReservation ? 'silver-background' : ''}` }, children)));
});
{
    /* <MenuBox
    isTeacher={isTeacher}
    name={name}
    isWhite={isWhite}
    menuList={menuList}
    hideBody={hideBody}
/> */
}
// const default_questionType = { id: 'select', title: 'common.select' };
// export const DSBodyTitle = React.memo(
// 	({ title, isWhite = false }: { title: string; isWhite?: boolean }) => {
// 		const [questionType, setQuestionType] = useState<DropdownItemProps>(default_questionType); // 출제 유형
// 		//나의 강의실 메뉴
// 		const questionTypeList: DropdownItemProps[] = [
// 			{ id: 'assignment', title: 'menu.assignment' },
// 			{ id: 'test', title: 'menu.test' },
// 			{ id: 'gradeCard', title: 'menu.gradeCard' },
// 		];
// 		const { isDesktop } = useGlobalState();
// 		return (
// 			<div className="title-live" style={{ padding: !isDesktop && ' 12px 20px 12px 20px' }}>
// 				{!isDesktop && (
// 					<DropDown
// 						className="dropdown-tablet"
// 						value={questionType}
// 						styles={{
// 							titleWrap: {
// 								display: 'flex',
// 							},
// 						}}
// 						option={{
// 							downIcon: {
// 								name: 'menu_open',
// 							},
// 							itemIcon: {
// 								show: true,
// 								size: 35,
// 							},
// 						}}
// 						list={questionTypeList}
// 						setDropValue={setQuestionType}
// 						isHeaderTitle={true}
// 					/>
// 				)}
// 				<Icon icon="message" size={32} fill={isWhite ? Colors.white : Colors.light_tur} />
// 				<p className="title-name">{title}</p>
// 			</div>
// 		);
// 	}
// );
exports.DSSBodyTitle = react_1.default.memo(({ title }) => {
    return (react_1.default.createElement("div", { className: "title", style: {
            background: 'var(--bule-d, #5168aa)',
            borderRadius: '50px',
            padding: '24px 52px 24px 52px',
        } },
        react_1.default.createElement(common_1.Icon, { icon: "message", size: 32, fill: Colors_1.Colors.white }),
        react_1.default.createElement("p", { className: "title-name", style: { color: 'var(--color-white, #ffffff)' } }, title)));
});
exports.DSBodyLeftLayout = react_1.default.memo(({ children }) => {
    return react_1.default.createElement(react_1.default.Fragment, null, children);
});
exports.DSBodyRightLayout = react_1.default.memo(({ children }) => {
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const { menu } = (0, react_redux_1.useSelector)((state) => (0, function_1.getMenuData)(state), react_redux_1.shallowEqual);
    const isStudentReservation = !isTeacher && menu.menu === 'reservation';
    return (react_1.default.createElement("div", { className: `right-wrapper ${isStudentReservation ? 'no-background' : ''}` },
        react_1.default.createElement("div", { className: "right-wrap" }, children)));
});
